// extracted by mini-css-extract-plugin
export var aboveInput = "_jb-0";
export var actionButton = "_jb-5";
export var actionButtonContainer = "_jb-1";
export var actionIcon = "_jb-6";
export var aiInfoContainer = "_jb-2";
export var attachmentWrapper = "_jb-7";
export var bold = "_jb-3";
export var checkIcon = "_jb-8";
export var clickingRecipientBar = "_jb-11";
export var commentThreadSwitch = "_jb-a";
export var draftImage = "_jb-b";
export var draftImageContainer = "_jb-c";
export var draftImages = "_jb-e";
export var editButton = "_jb-g";
export var editor = "_jb-f";
export var editorContainer = "_jb-y";
export var editorErrorTooltipWrapper = "_jb-9";
export var headerDivider = "_jb-h";
export var icon = "_jb-i";
export var info = "_jb-j";
export var internal = "_jb-n";
export var internalDivider = "_jb-k";
export var internalMessage = "_jb-l";
export var messageInputCard = "_jb-m";
export var messageInputForm = "_jb-o";
export var messageInputFormInternal = "_jb-p";
export var options = "_jb-q";
export var publicMessageCustomer = "_jb-s";
export var publicMessageMerchant = "_jb-r";
export var removeImageButton = "_jb-d";
export var replyButtons = "_jb-t";
export var showSignatureButton = "_jb-u";
export var spinner = "_jb-v";
export var verticalButtonDivider = "_jb-4";
export var visibilitySelector = "_jb-w";
export var warning = "_jb-x";
export var wrappingText = "_jb-z";
export var writingInternalNoteTopBorder = "_jb-10";